<template>
  <div id="search-results">
    <section v-if="error && isMobile !== 'mobile'">
      <search-error :county="county" :error="error" />
    </section>
    <pagination
      v-if="
        status === 'ready' ||
          (status === 'recentParcels' && items.length && !error)
      "
      :hidePageLinks="true"
      :item="pagination"
    />
    <div
      v-if="
        (status === 'ready' || status === 'recentParcels') &&
          currentPayYear &&
          items.length &&
          !error
      "
      class="table-responsive" style="overflow-x: visible"
    >
      <table class="table table-sm table-hover">
        <tbody>
          <tr
            v-for="(item, index) in items"
            v-on:click="showParcel(item)"
            :key="index"
            class="border-bottom"
            :class="{ 'border-dark': isMobile == 'mobile' }"
          >
            <td v-if="county.photoUrlPrefix">
              <h4 class="column-head">
                {{ item.StateKey }}
              </h4>
              <img
                v-if="item.Photo"
                :alt="
                  'photo of ' +
                    item.PropertyAddress1 +
                    ', ' +
                    item.PropertyCity +
                    ' Indiana'
                "
                class="rounded"
                @error="loadHomeIcon"
                :src="
                  item.Photo.substring(0, 4).toLowerCase() == 'http'
                    ? item.Photo
                    : county.photoUrlPrefix + item.Photo
                "
                width="195"
              />
              <img
                v-else
                alt="no photo available for this parcel"
                height="130"
                :src="baseUrl + 'images/icons/home-o.svg'"
                width="195"
              />
            </td>
            <td v-else>
              <h4 class="column-head">
                {{ item.StateKey }}
              </h4>
              <div class="space-above">
                <span class="text-muted">Property Address</span>
                <br />
                <span>
                  {{ item.PropertyAddress1 }}
                </span>
                <span v-if="item.PropertyAddress2">
                  <br />
                  {{ item.PropertyAddress2 }}
                </span>
                <br />
                <span v-if="item.PropertyCity">
                  {{ item.PropertyCity }},
                  {{ item.PropertyState }}
                  {{ item.PropertyZipCode }}
                </span>
              </div>
            </td>
            <td v-if="county.photoUrlPrefix">
              <h4 class="column-head">
                {{ item.OwnerOfRecord }}
              </h4>
              <div class="center">
                <div v-if="item.MailingAddress1 !== item.PropertyAddress1">
                  <span>
                    {{ item.PropertyAddress1 }}
                  </span>
                  <span v-if="item.PropertyAddress2">
                    <br />
                    {{ item.PropertyAddress2 }}
                  </span>
                  <br />
                  <span v-if="item.PropertyCity">
                    {{ item.PropertyCity }},
                    {{ item.PropertyState }}
                    {{ item.PropertyZipCode }}
                  </span>
                  <br />
                  <div class=" space-above">
                    <span class="text-muted">Mailing Address</span>
                    <br />
                    <span>
                      {{ item.MailingAddress1 }}
                    </span>
                    <span v-if="item.MailingAddress2">
                      <br />
                      {{ item.MailingAddress2 }}
                    </span>
                    <span>
                      <br />
                      {{ item.MailingCity }},
                      {{ item.MailingState }}
                      {{ item.MailingZipCode }}
                    </span>
                  </div>
                </div>
                <div class="single-address" v-else>
                  <span>
                    {{ item.PropertyAddress1 }}
                  </span>
                  <span v-if="item.PropertyAddress2">
                    <br />
                    {{ item.PropertyAddress2 }}
                  </span>
                  <br />
                  <span v-if="item.PropertyCity">
                    {{ item.PropertyCity }},
                    {{ item.PropertyState }}
                    {{ item.PropertyZipCode }}
                  </span>
                </div>
                <div v-if="status === 'recentParcels'" class="mt-2">
                  <span><b>Duplicate#</b>&nbsp;{{ item.DuplicateNumber }}</span>
                </div>
              </div>
            </td>
            <td v-else>
              <h4 class="column-head">
                {{ item.OwnerOfRecord }}
              </h4>
              <span class="text-muted">Mailing Address</span>
              <div v-if="item.MailingAddress1 !== item.PropertyAddress1">
                <span>
                  {{ item.MailingAddress1 }}
                </span>
                <span v-if="item.MailingAddress2">
                  <br />
                  {{ item.MailingAddress2 }}
                </span>
                <span>
                  <br />
                  {{ item.MailingCity }},
                  {{ item.MailingState }}
                  {{ item.MailingZipCode }}
                </span>
              </div>
              <div v-else>
                <span>
                  {{ item.PropertyAddress1 }}
                </span>
                <span v-if="item.PropertyAddress2">
                  <br />
                  {{ item.PropertyAddress2 }}
                </span>
                <br />
                <span v-if="item.PropertyCity">
                  {{ item.PropertyCity }},
                  {{ item.PropertyState }}
                  {{ item.PropertyZipCode }}
                </span>
              </div>
              <div v-if="status === 'recentParcels'" class="mt-2">
                <span><b>Duplicate#</b>&nbsp;{{ item.DuplicateNumber }}</span>
              </div>
            </td>
            <td v-if="status !== 'recentParcels'">
              <div
                v-if="
                  item.Status.trim().toUpperCase() !== 'I' ||
                    item.CurrentAccountBalance > 0
                "
              >
                <div class="d-flex justify-content-center mt-column-head">
                  <div class="w-50 text-end">
                    <span class="pay-bold">Spring Due:</span>&nbsp;
                  </div>
                  <div class="w-50 text-start">
                    <span class="pay-bold">{{
                      formatDollarAmount(item.SpringBalanceDue) || "$0.00"
                    }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  Spring Due by
                  {{ toSlashDateFormat(item.SpringDueDate) }}
                </div>
                <div class="d-flex justify-content-center">
                  <div class="w-50 text-end">
                    <span class="pay-bold">Fall Due:</span>&nbsp;
                  </div>
                  <div class="w-50 text-start">
                    <div class="pay-bold">
                      <span>{{
                        formatDollarAmount(item.FallBalanceDue) || "$0.00"
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  Fall Due by
                  {{ toSlashDateFormat(item.FallDueDate) }}
                </div>
              </div>
              <div
                v-if="
                  item.Status.trim().toUpperCase() === 'I' &&
                    !item.CurrentAccountBalance
                "
              >
                <h4 class="text-dark column-head">INACTIVE PARCEL</h4>
              </div>
              <div
                class="total-balance-container d-flex justify-content-center align-items-center"
              >
                <h3 class="account-balance">
                  {{
                    formatDollarAmount(item.CurrentAccountBalance) || "$0.00"
                  }}
                </h3>
                <div @click.stop>
                  <div
                    class="text-muted no-padding d-flex flex-row balance-info-button"
                    type="button"
                    data-bs-toggle="modal"
                    :data-bs-target="`#balance-info-modal`"
                    @click="openBalanceInfo(item.DuplicateNumber)"
                    title="Balance Information"
                  >
                    <p class="mb-0 ms-3">Total Due</p>
                    &nbsp;
                    <info-circle class="balance-info-circle" />
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-center align-items-center mt-2"
              >
                <span><b>Duplicate#</b>&nbsp;{{ item.DuplicateNumber }}</span>
              </div>
            </td>
            <td>
              <div class="button-container">
                <pay-bill-button
                  :county="county"
                  :dup="item.DuplicateNumber"
                  :currentPayYear="item.PayYear"
                  :stateKey="item.StateKey"
                  :unformattedStateKey="item.UnformattedStateKey"
                  :currentAccountBalance="item.CurrentAccountBalance || 0"
                  :status="status"
                  :taxType="item.TaxType"
                  :SpringBalanceDue="item.SpringTax"
                  :FallBalanceDue="item.FallTax"
                  :inactiveZeroBalance="
                    item.Status.trim().toUpperCase() === 'I' &&
                      !item.CurrentAccountBalance
                  "
                />
                <property-details-button
                  :updateRecentParcels="updateRecentParcels"
                  :item="item"
                  :stateKey="item.StateKey"
                  :unformattedStateKey="item.UnformattedStateKey"
                  :county="county"
                  :status="status"
                  :currentPayYear="currentPayYear"
                  :showEFormsAlert="showEFormsAlert"
                  :inactiveZeroBalance="
                    item.Status.trim().toUpperCase() === 'I' &&
                      !item.CurrentAccountBalance
                  "
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-else-if="status === 'recentParcels' && !currentPayYear"
      class="d-flex justify-content-center my-4"
    >
      <span class="spinner-border spinner-border-lg" role="status"></span
      >&nbsp;&nbsp;
      <h3>Loading</h3>
    </div>

    <!-- pagination -->
    <pagination
      v-if="
        (status === 'ready' || status === 'recentParcels') &&
          items.length &&
          !error
      "
      :hideStats="true"
      :item="pagination"
    />
  </div>
</template>

<style scoped>
#search-results table {
  border-top: 1px solid #dee2e6;
}
.desktop table tr td {
  padding: 0.75rem;
}
.desktop table tr td:nth-child(1) {
  min-width: 225px;
}
.desktop table tr td:nth-child(2) {
  min-width: 195px;
  max-width: 275px;
}

.desktop table tr td:nth-child(4) {
  width: 165px;
}
table {
  font-size: small;
}
tr {
  cursor: pointer;
}
.mobile tr {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.mobile td {
  border: none;
}
.column-head {
  margin: 0.7rem 0 0.5rem 0;
  font-size: 1.15rem;
}
.mt-column-head {
  margin-top: 0.7rem;
}

.mobile .column-head {
  font-size: 1.4rem;
}
.single-address {
  margin-top: 2rem;
}
.space-above {
  margin-top: 1rem;
}
.button-container {
  display: flex;
  flex-direction: column;
}
.mobile .button-container {
  align-items: center;
  justify-content: center;
}
.mobile span {
  font-weight: 500;
  font-size: 1.2rem;
}
.total-balance-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  margin-bottom: 0.5rem;
}
.account-balance {
  margin: 0.8rem 0 0 0;
  padding-bottom: 0;
  font-size: 1.75rem;
  line-height: 1.75rem;
}
.no-padding {
  padding: 0;
  margin: 0;
}
.dup-container {
  margin-top: 0.5rem;
}
.balance-info-button {
  cursor: pointer;
}
.balance-info-button:hover {
  text-decoration: underline;
}
.balance-info-button:hover .balance-info-circle {
  fill: #bad9d9;
}
.pay-bold {
  font-weight: 800;
}
</style>

<script>
import Pagination from "../common/PaginationComponent.vue";
import SearchError from "../common/SearchError.vue";
import PropertyDetailsButton from "./PropertyDetailsButton.vue";
import PayBillButton from "./PayBillButton.vue";
import InfoCircle from "../svg/InfoCircle.vue";
import { formatDollarAmount, toSlashDateFormat } from "../../utilities.ts";

export default {
  components: {
    Pagination,
    SearchError,
    PayBillButton,
    PropertyDetailsButton,
    InfoCircle,
  },
  computed: {
    getHeroImageAltText() {
      return (
        this.county.heroImageAltText || this.county.name + " county Indiana"
      );
    },
    heroImageURL() {
      return this.county.corpCode
        ? this.baseUrl + "images/county/hero/" + this.county.corpCode + ".jpg"
        : this.baseUrl + "images/county/hero/default.jpg";
    },
    searching() {
      return Object.keys(this.$route.query).length > 0;
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      parcel: {},
      currentDup: null,
      // EFormsAlert: false,
    };
  },
  methods: {
    openBalanceInfo(dup) {
      this.updateBalanceInfoLink(dup);
      // event.stopPropagation();
    },
    loadDefaultImage(el) {
      el.target.alt = "Indiana state capitol building";
      el.target.src = this.baseUrl + "images/county/hero/default.jpg";
    },
    loadHomeIcon(el) {
      el.target.alt = "no photo available for this parcel";
      el.target.src = this.baseUrl + "images/icons/home-o.svg";
    },
    showParcel(item) {
      if (this.status == "recentParcels") {
        this.hideBackdrop("recent-parcels-modal");
      }
      this.updateRecentParcels(item.DuplicateNumber, item);
      localStorage.setItem("activeParcel", JSON.stringify(item));
      this.$router.push({
        name: "parcel",
        params: {
          dup: item.DuplicateNumber,
          payYear: item.PayYear,
        },
      });
    },
    formatStateKey(stateKey) {
      if (typeof stateKey !== "string" || stateKey.length !== 18) return;
      let result = "";
      let index = 0;
      const separationArr = ["-", "-", "-", "-", ".", "-"];
      const countArr = [2, 2, 2, 3, 3, 3, 3];
      while (countArr.length && index < stateKey.length) {
        let currCount = 0;
        let sectionCount = countArr.shift();
        while (currCount < sectionCount) {
          result += stateKey[index];
          currCount += 1;
          index += 1;
        }
        if (separationArr.length) {
          result += separationArr.shift();
        }
      }
      return result;
    },
    formatDollarAmount: formatDollarAmount,
    toSlashDateFormat: toSlashDateFormat,
  },
  props: {
    county: {
      required: true,
      type: Object,
    },
    error: {
      default: null,
      required: false,
      type: Error,
    },
    items: {
      required: true,
      type: Array,
    },
    pagination: {
      required: true,
      type: Object,
    },
    status: {
      // ready|cancelled|searching|error|recentParcels
      required: true,
      type: String,
    },
    updateRecentParcels: {
      type: Function,
      required: true,
    },
    currentPayYear: {
      type: String,
      required: false,
    },
    isMobile: {
      // mobile|desktop
      type: String,
      required: true,
    },
    hideBackdrop: {
      type: Function,
      required: false,
    },
    showEFormsAlert: {
      type: Function,
      required: false,
    },
    updateBalanceInfoLink: {
      type: Function,
      required: false,
    },
  },
};
</script>
